import api from '@/servicos/api'

export default {
  email(mailoptions) {
    return api().post('/email', mailoptions)
  },
}

